<template lang="pug">
    .box-loading
      .loader(v-bind:class="[isOpacity ? 'showing' : '']")
        .loader-wheel
        .loader-text {{textLoading}}
</template>
<script>
export default {
  props: {
    isOpacity: 0
  },
  data() {
    return {
      textLoading: this.$t('home.loading')
    }
  }
}
</script>
<style lang="scss" scoped>
    .box-loading{align-items: center; display: flex;height: 100%;justify-content: center;margin: 0;width: 100%;
      .loader {width: 60px; text-align: center; position: relative; opacity: 0;
        &.showing{opacity: 1;}
        .loader-wheel {animation: spin 1s infinite linear; border: 3px solid rgba(30, 30, 30, 0.5);border-left: 4px solid #fff;border-radius: 50%;height: 60px;margin-bottom: 10px;width: 60px;}
        .loader-text{top: 20px;font-size: 12px;position: absolute; margin: auto; width: 100%;}
        @keyframes spin {
          0% {transform: rotate(0deg);}
          100% {transform: rotate(360deg);}
        }
      }
    }
</style>



// WEBPACK FOOTER //
// index.vue?b20ad420